/** Keep application links on the current origin, including old loopback links. */
export function localLink(href: string): string | null {
  try {
    const url = new URL(href, window.location.href);
    if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password) return null;
    const current = window.location;
    const loopback = new Set(['localhost', '127.0.0.1', '[::1]']);
    const legacyWorkbench = loopback.has(current.hostname) && loopback.has(url.hostname)
      && url.port === current.port && url.pathname === '/'
      && /^#\/(?:zustand-[ft]|foerderungen|technologie|chat-[ft]|schaerfen-[ft])(?:\?|$)/.test(url.hash);
    if (url.origin !== current.origin && !legacyWorkbench) return null;
    return url.pathname + url.search + url.hash;
  } catch {
    return null;
  }
}
